var accountSearchForm = function(form) {
    $(form).parsley();
    $(form).on('submit',function($e){   
        var $q = $(form + ' input[name="q"]').val();
        $(form).closest('.partial').data('q', $q);
        load_partial($(form).closest('.partial'));
        return false;       
    });
};

var user_order = {
	  filter_orders:function(container){
       $('.order-filters-item').removeClass('rounded-tag');
        $(container).addClass('rounded-tag');
        var status = $(container).data('status');
        var p = $('#orders');
        p.data('page',1);
        p.data('status',status);
        scroll2element($('#orders').get());
        load_partial(p);
        return false;
	  }
}


var addresses = {
      make_default:function(address_id){
         var $this = this;
         $.ajax({
            type: "POST", 
            url: "/addresses/make-default",
            data: { 
               address_id: address_id,  
            },
            success:function(data){ 
                 actionResponseModal(data.success,'success','.actions-block .save'); 
                  window.location.reload();
            },
            error:function(){
               actionResponseModal(data.message,'error','.actions-block .save'); 
            }
         });
     
        return false;
      },
      
      update:function(container){
         var $this = this;

         $.extend({}, AjaxForms , {
            options:{
               stop_response:true,
               api_route : BASE_URL +'/orders',
               successFn:function(){
                  
                  var u = BASE_URL + '/'+CURRENT_LANGUAGE +'/thank-you';

                  if( $("#ajaxModal .modal-body:visible").length > 0 ){

                     $("#ajaxModal .modal-body").load( u + " #ajax-content .content-main" , function(){
                        
                        $('#ajaxModal').modal('show');         
                        initForm("#ajaxModal .modal-body");
                     
                     });

                     $this.refresh();

                  }else{

                     window.location = u;

                  }
               
               }

           }}).init('#checkout_step_1_form');
        return false;
      }
}


